/* eslint-disable react/prop-types */
import classes from "./quote-form.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import Grid from "@/components-library/layout/grid";
import TextField from "@/components-library/widgets/text-field";
import Checkbox from "@/components-library/widgets/checkbox";
import Button from "@/components-library/widgets/button";
import Spinner from "@/components-library/widgets/spinner";
import * as appSlice from "@/app/app.slice";
import Modal from "@/components-library/widgets/modal";
import Iubenda from "react-iubenda-policy";
function QuoteForm({
  announcements,
  services,
  name,
  surname,
  businessName,
  phone,
  email,
  onEmailChange,
  onNameChane,
  onSurnameChange,
  onPhoneChange,
  onBuisinessNameChange,
  onSendReuqestClick,
  isSendRequestEnabled,
  isPravacySelcted,
  onPrivacySelect,
  vatNumber,
  onVatNumberChane,
  status,
}) {
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

  return (
    <Grid columns={isMobile ? "1fr" : "1fr 1fr"} className={classes.container}>
      <Modal isOpen={status === appSlice.Status.ASKING}>
        <Spinner />
      </Modal>
      <Flex
        align="flex-start"
        direction="column"
        justify="space-between"
        className={classes.overview}
      >
        <Flex align="flex-start" direction="column" justify="flex-start">
          <Label
            tag="h4"
            weight="bold"
            align="start"
            style={{ marginBottom: "1rem" }}
          >
            PRODOTTI SELEZIONATI
          </Label>
          <Label
            tag="p"
            size="md"
            align="start"
            style={{ marginBottom: "1rem" }}
          >
            Hai selezionato i seguenti bandi:
          </Label>
          {announcements.map((name, index) => (
            <Flex
              align="flex-start"
              direction="column"
              justify="flex-start"
              key={name}
              className={classes.announcement}
            >
              <Flex align="center" direction="row" justify="flex-start">
                <Label
                  tag="p"
                  size="md"
                  align="start"
                  className={classes.index}
                >
                  {index + 1}
                </Label>
                <Label tag="p" size="md" align="start">
                  {name}
                </Label>
              </Flex>
              <div className={classes.separator} />
            </Flex>
          ))}
          {services.length && (
            <Label
              tag="p"
              size="md"
              align="start"
              style={{ marginBottom: "1rem" }}
            >
              Hai selezionato i seguenti servizi:
            </Label>
          )}
          {services.map((name, index) => (
            <Flex
              align="flex-start"
              direction="column"
              justify="flex-start"
              className={classes.announcement}
              key={name}
            >
              <Flex align="center" direction="row" justify="flex-start">
                <Label
                  tag="p"
                  size="md"
                  align="start"
                  className={classes.index}
                >
                  {index + 1}
                </Label>
                <Label tag="p" size="md" align="start">
                  {name}
                </Label>
              </Flex>
              <div className={classes.separator} />
            </Flex>
          ))}
        </Flex>
      </Flex>
      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.form}
      >
        <Label tag="h4" weight="bold" color="secondary" align="start">
          {
            "Compila il form per ricevere\ninformazioni sui prodotti selezionati"
          }
        </Label>

        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classes.textField}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Nome *
          </Label>
          <TextField
            type="text"
            isEnabled={true}
            onChange={onNameChane}
            value={name}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classes.textField}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Cognome *
          </Label>
          <TextField
            type="text"
            isEnabled={true}
            onChange={onSurnameChange}
            value={surname}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classes.textField}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Ragione sociale *
          </Label>
          <TextField
            type="text"
            isEnabled={true}
            onChange={onBuisinessNameChange}
            value={businessName}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classes.textField}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Telefono *
          </Label>
          <TextField
            type="text"
            isEnabled={true}
            onChange={onPhoneChange}
            value={phone}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classes.textField}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Email *
          </Label>
          <TextField
            type="text"
            isEnabled={true}
            onChange={onEmailChange}
            value={email}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classes.textField}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            P.iva
          </Label>
          <TextField
            type="text"
            isEnabled={true}
            onChange={onVatNumberChane}
            value={vatNumber}
          />
        </Flex>

        <Flex align="center" direction="row" justify="flex-start">
          <Checkbox
            name="all"
            label="Ho letto e accettato l’Informativa sulla "
            isChecked={isPravacySelcted}
            isEnabled={true}
            onClick={onPrivacySelect}
            className={classes.checkbox}
          />
          <Iubenda id={60147723} type="privacy" styling="white">
            Privacy Policy
          </Iubenda>
        </Flex>
        <Button
          onClick={onSendReuqestClick}
          isEnabled={isSendRequestEnabled}
          size="sm"
          color="primary"
          className={classes.button}
        >
          RICHIEDI PREVENTIVO
        </Button>
      </Flex>
    </Grid>
  );
}

export default QuoteForm;
